import React from 'react'
import Navbar from '../components/Navbar'
import FAQsQuestion from '../components/FAQsQuestion'
import Footer from '../components/Footer'

const FAQa = () => {
  return (
    <>
    <Navbar/>
    <FAQsQuestion/>
    <Footer/>
    </>
  )
}

export default FAQa
